import emojiRegex from "emoji-regex";
import { addMethod, string as yupString } from "yup";

import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

addMethod(yupString, "blockEmoji", function () {
    return this.test("blockEmoji", function (value) {
        const errorMessage = translateWithoutContext(
            "general.form.input.validation.emoji.invalid",
        );
        if (!emojiRegex().test(value || "")) {
            return true;
        }
        return this.createError({ message: errorMessage });
    });
});

export const string = () => {
    return yupString().trim().blockEmoji();
};
